import React from 'react';
import styles from './Spinner.module.css';

const spinner = () => (
  <div className={styles.loader}>Loading...</div>
)

export default spinner;